import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=0eb6b2c6&"
import script from "./OptionCard.vue?vue&type=script&lang=js&"
export * from "./OptionCard.vue?vue&type=script&lang=js&"
import style0 from "./OptionCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports